// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"455b6e63","591":"9e2dc51b","788":"f34a5a5c","983":"69d98d16"}[chunkId] + ".chunk.css";
};